<template>
  <NavPanel :panelNavLinks="panelNavLinks">
    <template
      v-for="(_, slot) in $slots"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="{...scope}"
      />
    </template>
  </NavPanel>
</template>

<script setup>
import { computed } from 'vue';

// Utils
import I18n from 'i18n-js';
import isKey from '@/functions/existing_key';
import isExistingIssue from '@/functions/existing_issue';
import { useRoute } from 'vue-router';
import { useOperation } from '@/functions/use_remote_object';

// Components
import NavPanel from '@/components/issues/nav_panel.vue';

const route = useRoute();

const currentOperation = useOperation({ organisationId: route.params.organisationId, operationId: route.params.operationId });

const editLinks = [
    {
      id: 'Plant',
      name: 'issueLocationPlant',
      label: I18n.t('plants.plant'),
    },
    {
      id: 'Hme',
      name: 'issueLocationHmes',
      label: I18n.t('plants.heavy_mobile_equipment'),
    }
  ];

const newLinks = [
    {
      id: 'Plant',
      name: 'newIssueLocationPlant',
      label: I18n.t('plants.plant'),
    },
    {
      id: 'Hme',
      name: 'newIssueLocationHmes',
      label: I18n.t('plants.heavy_mobile_equipment'),
    }
  ];

const panelNavLinks = computed(() => {
  let links = [];

  const isHmePolicy = currentOperation.value?.policy?.heavy_mobile_equipment_enabled;

  if (isExistingIssue(route.params)) {
    // When editing the issue location it will only show the location type associated to the existing issue location
    switch (true) {
      case isKey(route.params, 'heavyMobileEquipmentId'):
        links = [ editLinks[1] ];
        break;
      case isKey(route.params, 'operationId'):
        links = [ editLinks[0] ];
        break;
    }
  } else {
    // When creating an issue location it will show all relevant location types to choose from
    links = [
      newLinks[0],
    ];
    isHmePolicy && links.push(newLinks[1]);
  }

  return links;
});
</script>
